export const HOUSE_NAMES = {
  GARDENIA: "Gardenia",
};
